export const Typography = {
    weight: {
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
    size: {
        10: 10,
        12: 12,
        14: 14,
        16: 16,
        18: 18,
        20: 20,
        24: 24,
        32: 32,
        40: 40,
        48: 48,
        56: 56,
        64: 64,
        72: 72,
        80: 80,
    },
    lineHeight: {
        // rem
        "0.625": 0.625,
        "0.75": 0.75,
        "0.875": 0.875,
        "1": 1,
        "1.125": 1.125,
        "1.3125": 1.3125,
        "1.5": 1.5,
        "1.875": 1.875,
        "2.25": 2.25,
        "3": 3,
        "3.125": 3.125,
        "3.75": 3.75,
        "4.375": 4.375,
        "5": 5,
        "5.625": 5.625,
        "6.25": 6.25,
    }
} as const;
